/**
 * Custom event name dispatched by anything that wants to open the keyboard
 * shortcuts dialog (e.g. the ProfileMenu's "Keyboard shortcuts" entry).
 *
 * Lives in its own file (with no other imports) so both `App.tsx` and
 * `ProfileMenu.tsx` can read it without setting up a circular dependency
 * — putting the constant in `App.tsx` produces an import cycle
 * `App → MainRoutes → ... → ProfileMenu → App` that can leave the export
 * unresolved at the moment ProfileMenu's module body runs.
 */
export const OPEN_KEYBOARD_SHORTCUTS_EVENT = 'open-keyboard-shortcuts';
